import React from "react";
import { confirmDialog } from "primereact/confirmdialog";

export const ConfirmBlockDialog = ({ userId, isBlocked, onAccept }) => {
    const actionType = isBlocked ? 'unblock' : 'block';
    const message = isBlocked
        ? "Are you sure you want to activate this user?"
        : "Are you sure you want to ban this user?";

    const showDialog = () => {
        confirmDialog({
            message,
            header: "Confirmation",
            icon: isBlocked ? "pi pi-check-circle" : "pi pi-ban",
            acceptClassName: isBlocked ? "p-button-success" : "p-button-danger",
            accept: () => onAccept(userId, actionType),
            reject: () => { },
        });
    };

    const BRAND_BLUE = "#0147C8";

    return (
        <button
            style={{ backgroundColor: isBlocked ? BRAND_BLUE : 'red', borderColor: isBlocked ? BRAND_BLUE : 'red' }}
            type="button"
            className={`btn btn-sm ${isBlocked ? 'btn-primary' : 'btn-danger'}`}
            onClick={showDialog}
        >
            {isBlocked ? (
                <i className="mdi mdi-account-check"></i> // ✅ Active
            ) : (
                <i className="mdi mdi-block-helper"></i> // ❌ Ban
            )}
        </button>
    );
};

export const ConfirmResetDialog = ({ userId, onAccept, isBlocked }) => {
    const message = "Are you sure you want to reset this user's password?";

    const showDialog = () => {
        confirmDialog({
            message,
            header: "Confirmation",
            icon: "pi pi-question-circle",
            accept: () => onAccept(userId),
            reject: () => { },
        });
    };

    const BRAND_BLUE = "#0147C8";

    return (
        <button
            style={{ backgroundColor: BRAND_BLUE, borderColor: BRAND_BLUE }}
            type="button"
            className="btn btn-primary btn-sm"
            onClick={showDialog}
            disabled={isBlocked} // ✅ disable if banned
        >
            <i className="mdi mdi-lock-reset"></i>
        </button>
    );
};
